import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Box, CircularProgress, Typography } from '@mui/material';
import { getJITUser } from '../../services/jitApi';
import { getKeycloakURL } from '../../utils/constants';

/**
 * JITRealmRedirect handles realm-based routing for the JIT portal.
 *
 * URL: jit.prism.cloudkeeper.com/r/{realm}
 *
 * Behavior:
 * - If user is logged in → redirect to main JIT portal (/)
 * - If user is not logged in → initiate SAML login via Keycloak with RelayState=jit,
 *   which routes through the proxy's JIT auth flow and back to /sso-callback
 */
const JITRealmRedirect = () => {
  const { realm } = useParams();

  useEffect(() => {
    const user = getJITUser();

    if (user) {
      // User is logged in - redirect to main JIT portal
      window.location.replace('/');
    } else {
      // Redirect to Keycloak IDP-initiated SSO with RelayState=jit.
      // This triggers the same SAML flow as the proxy app tray:
      // Keycloak → proxy SAML ACS → handleJITPortalAuth → jit_sso_token cookie → /sso-callback
      const keycloakURL = getKeycloakURL();
      window.location.href = `${keycloakURL}/realms/${realm}/protocol/saml/clients/ckauth-admin?RelayState=jit`;
    }
  }, [realm]);

  // Show loading while redirecting
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#F9FBFD',
        gap: 2,
      }}
    >
      <CircularProgress sx={{ color: '#5D6D7E' }} />
      <Typography
        sx={{
          fontFamily: 'Metropolis, sans-serif',
          color: '#666666',
          fontSize: '0.9rem',
        }}
      >
        Redirecting...
      </Typography>
    </Box>
  );
};

export default JITRealmRedirect;
